import { assetsBucketUrl } from "..";

const bgImagesUrl = `${assetsBucketUrl}bgImages/`;

export const soyBeansUrl = `${bgImagesUrl}soyBeans.png`;
export const farmFieldsUrl = `${bgImagesUrl}farmFields.png`;
